module.exports = __webpack_public_path__ + "img/H1.e5ba5ceb.png";